<template>
  <v-menu :disabled="!btnState" @moteurCheckFalse="disable()">
    <template v-slot:activator="{ on }">
      <v-btn
        slot="activator"
        class="navbarButton middle v-step-4"
        transition="slide-y-transition v-step-4"
        v-on="on"
        :disabled="!btnState"
      >
        <v-icon>remove_red_eye</v-icon>
        Après
      </v-btn>
    </template>
    <v-list v-if="btnState">
      <v-list-item @click="route('Optimisation')">
        <v-list-item-title>
          <span class="menu-item-title"> Vision Globale </span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click="route('OptimisationFluxProduits')">
        <v-list-item-title>
          <span class="menu-item-title"> Flux Produits </span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click="route('OptimisationFluxSites')">
        <v-list-item-title>
          <span class="menu-item-title"> Flux Sites </span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click="route('OptimisationTauxDeRemplissages')">
        <v-list-item-title>
          <span class="menu-item-title"> Taux de remplissage </span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="!this.$store.state.userInfos.isViewer" @click="route('optimisationFiger')">
        <v-list-item-title>
          <span class="menu-item-title"> Figer </span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="!this.$store.state.userInfos.isViewer" @click="route('optimisationModifALaMarge')">
        <v-list-item-title>
          <span class="menu-item-title"> Modification à la marge </span>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      btnState: 'btnApresValue',
    }),
  },
  methods: {
    route(pathName) {
      this.$store.dispatch('stopIntervalTimer');
      this.$router.push({ name: pathName });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables';

.menu {
  margin-top: 6px;
  max-height: 36px;
}

.menu-item-title {
  color: white;
}

.menu-container {
  align-items: center;
}

.application span {
  cursor: pointer;
  color: white;
  font-variant: all-small-caps;
  font-size: 1.125rem;
  padding: 0.625rem;
}

.v-list-item__title {
  color: white;
}

.theme--light.v-list {
  background: $altGreen;
}

.v-list > div:hover {
  color: white;
  background: $altYellow !important;
}
</style>
